
export default class CookieBanner
{
    constructor(wrapper) {
        this.wrapper = wrapper;
        if(!this.wrapper) {
            return;
        }

        this.bind_elements();
        this.bind_events();
    }

    bind_elements() {
        this.banner = this.wrapper.querySelector('#bcc-banner');
        this.accept_action = this.wrapper.querySelector('#accept-action');
        this.reject_action = this.wrapper.querySelector('#reject-action');
        this.triggers = [...document.querySelectorAll('a[href="#manage-cookies"]')]
    }

    bind_events() {
        this.accept_action.addEventListener('click', this.accept_cookies.bind(this))
        this.reject_action.addEventListener('click', this.reject_cookies.bind(this))
        this.triggers.forEach(trigger => trigger.addEventListener('click', this.open.bind(this)))
    }

    accept_cookies() {
        this.set_cookie(true);
        this.event(this.wrapper, 'accepted')
        this.close();
    }

    reject_cookies() {
        this.set_cookie(false);
        this.event(this.wrapper, 'rejected')
        this.close();
    }

    set_cookie(value) {
        window.BCC.set_cookie('bcc_cookies_accepted', value);
    }

    open(event = null) {
        if (event) {
            event.preventDefault();
        }
        this.banner.classList.remove('is-closed');
    }

    close() {
        this.banner.classList.add('is-closed');
    }

    event(target, event) {
        if(typeof Event === 'function') {
            target.dispatchEvent(new Event(event));
        }
    }

}
